<template>
  <tr>
    <th class="kpi-performance-table__halfHeader">Actual</th>
    <th class="kpi-performance-table__halfHeader">BMK</th>
    <th class="kpi-performance-table__halfHeader">Prior Yr</th>
    <th class="kpi-performance-table__halfHeader">+/- BMK</th>
    <th class="kpi-performance-table__endColGroup kpi-performance-table__halfHeader">+/- Prior Yr</th>
    <th class="kpi-performance-table__halfHeader">Actual</th>
    <th class="kpi-performance-table__halfHeader">BMK</th>
    <th class="kpi-performance-table__halfHeader">Prior Yr</th>
    <th class="kpi-performance-table__halfHeader">+/- BMK</th>
    <th class="kpi-performance-table__endColGroup kpi-performance-table__halfHeader">+/- Prior Yr</th>
  </tr>
</template>

<script>
  export default {
    name: 'TableSubHead',
  };
</script>
